import ManualDeliveryContainer from "./ManualDelivery.container";

export default ManualDeliveryContainer;
